var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFilterOutline = function SvgIcoFilterOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.125 19.125a.75.75 0 0 1-.75-.75v-7.211L1.422 3.518A2.104 2.104 0 0 1 2.98 0H19.02a2.104 2.104 0 0 1 1.556 3.518l-6.952 7.646v4.211a.75.75 0 0 1-.281.585l-3.75 3a.75.75 0 0 1-.469.165M2.979 1.5a.604.604 0 0 0-.447 1.009l7.148 7.875a.75.75 0 0 1 .195.491v5.94L12.125 15v-4.125a.75.75 0 0 1 .195-.506l7.148-7.875a.605.605 0 0 0-.447-.994z"
  })));
};
export default SvgIcoFilterOutline;